import React, {useState} from 'react';

import { Button, Col, Row, Table } from 'antd';
import { Form } from 'react-bootstrap';
import { isAdministrator} from "utils/UserInfo";

import './statusTable.css';
import trashcan from "../../../assets/TasksImages/trashcan.png";
import {confirmAlert} from "react-confirm-alert";
import {defaultStatusColumns} from "../status.utils";

function StatusTable(props) {
  const {
    columns,
    dataSource,
    disabledButtons,
    dropOptions,
    fieldName,
    currentStatus,
    phaseId,
    disableDelete,
    handleProjectDetailUpdate
  } = props;

  const [status, setStatus] = useState(null);

  const handleStatusChange = (e) => {
    setStatus(e.target.value);
  };

  const addStatus = () => {
    handleProjectDetailUpdate(status, fieldName, 'string',phaseId,'A');
    setStatus('');
  };

  async function updateStatus(newStatus, action, auditId)
  {
    await handleProjectDetailUpdate(newStatus, fieldName, 'string', phaseId, action, auditId);
    setStatus('');
    return;
  }
  const clearAllStatus = () => {
    openStatusClearDialog(fieldName);
  };

  function openStatusClearDialog(){
    let headerMsg = 'Clear All Status ?';
    let bodyMsg = 'Are you sure? delete all status';

    confirmAlert({
      title: headerMsg,
      message: bodyMsg,
      buttons: [
        {
          label: 'No, Cancel',
        },
        {
          label: 'Yes, Delete',
          onClick: () => {updateStatus(null, 'C', null);}
        }
      ]
    });
  }

  const deleteColumn = [
    {
      title: '',
      dataIndex: 'auditId',
      key: 'auditId',
      render(text, record,i) {
        //console.log(record);
        return (i===0 ? <div><img src={trashcan} onClick={() => openStatusDeleteDialog(record.prevStatus, record.auditId)}/></div> : '')
      }
    }
  ];

  function openStatusDeleteDialog(newStatus, auditId){
    let headerMsg = 'Delete Current Status ?';
    let bodyMsg = 'Are you sure? delete current status';

    //console.log('dropdown',allDropDownOptions);
    confirmAlert({
      title: headerMsg,
      message: bodyMsg,
      buttons: [
        {
          label: 'No, Cancel',
        },
        {
          label: 'Yes, Delete',
          onClick: () => {updateStatus(newStatus, 'D', auditId);}
        }
      ]
    });
  }

  return (
    <>
      <Row align='top'>
        <Col span={2} className=' d-flex justify-content-end'>
          {' '}
          {/* <div className='p-2'>
            <b>Status:</b>
          </div> */}
        </Col>
        <Col span={22}>
          
          <div className='d-flex align-items-center '>
          <div className='p-2'>
            <b>Status:</b>
          </div>
            <Form.Control
              as='select'
              id='user-myprojects-selector'
              onChange={handleStatusChange}
              // value={selectectorStatus}
              value={status}
              style={{ width: '25%' }}
              disabled={currentStatus === 'SE Assets Created' || currentStatus === 'PCE Assets Created' || disabledButtons}
            >
              <option value=''> </option>
              {dropOptions?.map((s) => (
                <option value={s} key={s} disabled={currentStatus === null ? false : s === 'Received'}>
                  {s}
                </option>
              ))}
            </Form.Control>

            <Button
              type='primary'
              onClick={addStatus}
              disabled={!status || status==='' || disabledButtons}
            >
              Add
            </Button>
             <Col className='current-status'>
              <div className='d-flex flex-row'>
              <span className='key-title pr-1'>Current Status :</span>
              {dataSource?.length > 0 &&
                <div>
                  {currentStatus}
                  <span>{'   '}</span>
                  {isAdministrator() && fieldName !== 'CTRL_CIRCUIT_STATUS' &&
                  <Button
                      type={'primary'}
                      disabled={!currentStatus || disabledButtons}
                      onClick={() => clearAllStatus()}
                  >
                    Remove All Status
                  </Button>
                  }
                </div>}

            </div>
            </Col>
          </div>

          <Table
            bordered
            dataSource={dataSource}
            columns={isAdministrator() && !disableDelete ? [...defaultStatusColumns, ...deleteColumn] : [...defaultStatusColumns]}
            pagination={false}
            scroll={{ y: 250 }}
            style={{ paddingTop: '15px', paddingBottom: '15px' }}
          />
        </Col>
      </Row>
    </>
  );
};

export default StatusTable;
